import React from 'react'
import { createRoot } from 'react-dom/client'
import 'antd/dist/antd.css'
import '@ant-design/compatible/assets/index.css'

import './styles/main.scss'
import App from './App'

const root = createRoot(document.getElementById('root'))
root.render(<App />)
